import {
  ContainerLevelSimulationStatus,
  ContainerLevelSimulationUpdate,
} from "../../model/container-level-simulation";
import {otsBaseApi} from "../ots-api";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["ContainerLevelSimulation"]});

export const containerLevelSimulationApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getContainerLevelSimulation: builder.query<ContainerLevelSimulationStatus, void>({
      query: () => ({
        url: "/dev/simulation/container-levels",
        method: "GET",
      }),
      providesTags: [{type: "ContainerLevelSimulation", id: "STATUS"}],
    }),
    updateContainerLevelSimulation: builder.mutation<ContainerLevelSimulationStatus, ContainerLevelSimulationUpdate>({
      query: (body) => ({
        url: "/dev/simulation/container-levels",
        method: "PUT",
        body,
      }),
      invalidatesTags: [{type: "ContainerLevelSimulation", id: "STATUS"}],
    }),
  }),
});

export const {
  useGetContainerLevelSimulationQuery,
  useUpdateContainerLevelSimulationMutation,
} = containerLevelSimulationApi;
